import { navigate, type Route } from '../lib/router.js';
import { useAuth } from '../lib/auth.js';

const LINKS: Array<{ route: Route; label: string }> = [
  { route: 'overview', label: 'Overview' },
  { route: 'feedback', label: 'Feedback' },
  { route: 'roadmap', label: 'Roadmap' },
  { route: 'changelog', label: 'Changelog' },
  { route: 'players', label: 'Players' },
  { route: 'rooms', label: 'Live rooms' },
  { route: 'telemetry', label: 'Telemetry' },
  { route: 'progression', label: 'Progression' },
  { route: 'choir', label: 'Choir' },
  { route: 'flags', label: 'Flags' },
];

export function Nav({ current }: { current: Route }) {
  const { player, logout } = useAuth();
  return (
    <nav class="nav">
      <div class="nav-brand">STILLSUN</div>
      {LINKS.map((l) => (
        <a
          key={l.route}
          class={`nav-link${current === l.route ? ' active' : ''}`}
          onClick={(e) => {
            e.preventDefault();
            navigate(l.route);
          }}
          href={`#/${l.route}`}
        >
          {l.label}
        </a>
      ))}
      <div class="nav-spacer" />
      <div class="nav-user">
        <b>{player?.name}</b>
        {player?.role}
        <button type="button" class="btn btn-sm nav-logout" onClick={logout}>
          Log out
        </button>
      </div>
    </nav>
  );
}
